<template>
  <div
    style="display: block; position: relative"
    @click="ackNotification({ type: toWatches })"
  >
    <slot />
    <v-badge
      v-if="notificationCount > 0"
      bordered
      inline
      color="red"
      :content="notificationCount"
    />
  </div>
</template>

<script>
import { Howl } from "howler";
import { Echo } from "../plugins/pusher";

export default {
  name: "NotificationBadge",
  props: {
    watchOn: { type: String, required: true },
    servility: {
      type: String,
      default: "default",
      validator: (value) => ["low", "default", "high"].indexOf(value) !== -1,
    },
    persistentSound: { type: Boolean, default: false },
  },
  data() {
    return {
      servilitySound: {
        low: new Howl({
          src: ["/sound/sv-1.wav"],
          loop: this.persistentSound,
        }),
        default: new Howl({
          src: ["/sound/sv-2.wav"],
          loop: this.persistentSound,
        }),
        high: new Howl({
          src: ["/sound/sv-3.wav"],
          loop: this.persistentSound,
        }),
      },
      toWatches: [],
      notificationCount: 0,
    };
  },
  mounted() {
    switch (this.watchOn) {
      case "game-end-all":
        this.toWatches = [
          "game-end-lotto_thai",
          "game-end-lotto_thai2",
          "game-end-lotto_baac",
          "game-end-lotto_gsb",
          "game-end-lotto_vietnam",
          "game-end-lotto_malaysia",
          "game-end-lotto_lao",
          "game-end-lotto_lao_star",
          "game-end-stock_thai",
          "game-end-stock_japan",
          "game-end-stock_china",
          "game-end-stock_hangseng",
          "game-end-stock_taiwan",
          "game-end-stock_korea",
          "game-end-stock_singapore",
          "game-end-stock_india",
          "game-end-stock_egypt",
          "game-end-stock_russia",
          "game-end-stock_uk",
          "game-end-stock_germany",
          "game-end-stock_us",
          "game-end-yeekee_huay",
          "game-end-yeekee_jetsada",
          "game-end-yeekee_lotto",
          "game-end-yeekee_huay_vip",
          "game-end-yeekee_jetsada_vip",
          "game-end-step_lotto_vietnam",
          "game-end-step_lotto_malaysia",
          "game-end-step_lotto_lao",
          "game-end-lotto_lao_extra",
          "game-end-lotto_lao_hd",
          "game-end-lotto_lao_union",
          "game-end-lotto_lao_vip",
          "game-end-lotto_lao_star_vip",
          "game-end-lotto_vietnam_vip",
          "game-end-lotto_hanoi_vip",
          "game-end-lotto_hanoi_extra",
          "game-end-lotto_hanoi_hd",
          "game-end-lotto_hanoi_star",
          "game-end-lotto_hanoi_tv",
        ];
        break;
      case "game-end-stock":
        this.toWatches = [
          "game-end-stock_thai",
          "game-end-stock_japan",
          "game-end-stock_china",
          "game-end-stock_hangseng",
          "game-end-stock_taiwan",
          "game-end-stock_korea",
          "game-end-stock_singapore",
          "game-end-stock_india",
          "game-end-stock_egypt",
          "game-end-stock_russia",
          "game-end-stock_uk",
          "game-end-stock_germany",
          "game-end-stock_us",
        ];
        break;
      case "game-end-inter":
        this.toWatches = [
          "game-end-lotto_malaysia",
          "game-end-lotto_lao",
          "game-end-lotto_lao_star",
          "game-end-lotto_lao_extra",
          "game-end-lotto_lao_hd",
          "game-end-lotto_lao_union",
          "game-end-lotto_lao_vip",
          "game-end-lotto_lao_star_vip",
          "game-end-lotto_vietnam",
          "game-end-lotto_vietnam_vip",
          "game-end-lotto_hanoi_vip",
          "game-end-lotto_hanoi_extra",
          "game-end-lotto_hanoi_hd",
          "game-end-lotto_hanoi_star",
          "game-end-lotto_hanoi_tv",
        ];
        break;
      case "game-end-step":
        this.toWatches = [
          "game-end-step_lotto_vietnam",
          "game-end-step_lotto_malaysia",
          "game-end-step_lotto_lao",
        ];
        break;
      default:
        this.toWatches = [this.watchOn];
    }

    const channels = [];
    if (window.appState.user.roles.indexOf("admin") >= 0) {
      channels.push("admin");
    }

    if (
      window.appState.user.roles.indexOf("agent") >= 0 ||
      window.appState.user.roles.indexOf("subagent") >= 0
    ) {
      channels.push(`agent.${window.appState.user.agent_id}`);
    }

    if (channels.length > 0) {
      channels.forEach((channel) => {
        this.toWatches.forEach((listenTo) => {
          Echo.join(channel).listen(listenTo, (data) => {
            const playedItem = JSON.parse(localStorage.getItem(listenTo)) || [];
            this.notificationCount++;
            if (playedItem.indexOf(data.id) === -1) {
              this.servilitySound[this.servility].play();
            }
            // put played id at 0
            playedItem.splice(0, 0, data.id);
            // remove played id over 100
            playedItem.splice(100);
            localStorage.setItem(listenTo, JSON.stringify(playedItem));
          });
        });
      });
    }
  },
  methods: {
    ackNotification() {
      this.servilitySound[this.servility].pause();
      this.notificationCount = 0;
    },
  },
};
</script>
<style scoped>
.v-badge {
  transform: translateY(-125%);
  position: absolute;
  right: 1rem;
}
</style>
